import yup from './CustomValidation/yup-extended';

export const SummerActivityValidationSchema = yup.object().shape({
  schoolYear: yup.string(),
  leaIdentifier: yup.string(),
  leaName: yup.string(),
  schoolIdentifier: yup.string(),
  schoolName: yup.string(),
});
